import { useNavigate } from "react-router-dom";
import { Sparkles, BookOpen, Brain, Headphones, MessageCircle } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const navigate = useNavigate();

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const features = [
    { icon: BookOpen, label: "Revision Books", color: "bg-[#D4C4FB]" },
    { icon: Brain, label: "Flashcards", color: "bg-[#FFE066]" },
    { icon: Headphones, label: "AI Podcasts", color: "bg-[#9DFFB0]" },
    { icon: MessageCircle, label: "Study Chat", color: "bg-[#FFB38E]" },
  ];

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-zinc-950 flex items-center justify-center p-6">
      <div className="max-w-5xl w-full grid lg:grid-cols-2 gap-10 items-center">
        {/* Left */}
        <div>
          <div className="inline-flex items-center gap-2 nb-border rounded-full px-4 py-1.5 bg-[#FFE066] mb-6">
            <Sparkles className="w-4 h-4" strokeWidth={3} />
            <span className="label-caps">AI Study Sidekick</span>
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] text-black dark:text-white">
            Revise<br />smarter.<br />
            <span className="bg-[#D4C4FB] dark:bg-[#B794F4] px-3 nb-border rounded-2xl inline-block mt-2">
              Not harder.
            </span>
          </h1>
          <p className="mt-6 text-lg font-medium text-zinc-700 dark:text-zinc-300 max-w-md">
            Drop your notes. Get AI-generated revision books, flashcards, podcasts, and a personal study tutor, all organized by subject.
          </p>
          <button
            data-testid="login-google-btn"
            onClick={handleLogin}
            className="nb-button mt-8 px-8 py-4 text-lg bg-[#D4C4FB] dark:bg-[#B794F4]"
          >
            Continue with Google →
          </button>
          <div className="mt-3 flex items-center gap-3">
            <p className="text-sm font-medium text-zinc-600 dark:text-zinc-400">
              Free for students. No credit card. No spam.
            </p>
            <button
              data-testid="login-see-pricing"
              onClick={() => navigate("/pricing")}
              className="text-sm font-bold underline underline-offset-4"
            >
              See plans →
            </button>
          </div>
        </div>
        {/* Right */}
        <div className="grid grid-cols-2 gap-5">
          {features.map((f, i) => (
            <div
              key={f.label}
              className={`nb-border rounded-2xl ${f.color} p-6 nb-shadow-lg`}
              style={{ transform: `rotate(${i % 2 === 0 ? "-2deg" : "2deg"})` }}
            >
              <f.icon className="w-10 h-10 text-black" strokeWidth={2.5} />
              <div className="font-display font-extrabold text-xl mt-3 text-black">{f.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
